import { BehaviorSubject, Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { LoginResponse } from '../responses/login-response';
import { Tenant } from '../models';

@Injectable({
  providedIn: 'root'
})
export class TenantsService {

  private readonly subject = new BehaviorSubject<Tenant[]>([]);
  readonly tenants$ = this.subject.asObservable();

  constructor(private http: HttpClient) { }

  get(): Observable<Tenant[]> {
    return this.http.get(`${environment.apiUrl}/tenants`,) as Observable<Tenant[]>;
  }

  post(tenantId: string): Observable<LoginResponse> {
    return this.http.post(`${environment.apiUrl}/tenants`, { tenantId }) as Observable<LoginResponse>;
  }

}